import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { AdminUserDecorator } from "lib/decorators/index";

export default new (class UsersRepository extends BaseRepository {
  getAll() {
    return this.api
      .get(`/company/employees`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included));
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/UsersRepository.js